import { isClient } from 'helpers/isServer';
import { useEffect } from 'react';
import { v4 as uuid } from 'uuid';

type BroadcastChannelsType = 'reloadPage' | 'refetchCart' | 'orderCompleteBroadcast';

type CurrentCustomerUserBroadcast = {
    name: 'currentCustomerUserBroadcast';
    data: {
        currentCustomerUser: 'userInformation' | 'deliveryInformation' | 'contactInformation';
    };
};

type GlobalBroadcast = {
    name: BroadcastChannelsType;
};

type DispatchBroadcastChannelType = CurrentCustomerUserBroadcast | GlobalBroadcast;

const tabId = uuid();
const broadcastChannelSameTabConfig: Record<BroadcastChannelsType, boolean> = {
    refetchCart: false,
    reloadPage: false,
    orderCompleteBroadcast: false,
};

export const dispatchBroadcastChannel = (value: DispatchBroadcastChannelType): void => {
    const channel = isClient && 'BroadcastChannel' in window ? new BroadcastChannel(value.name) : undefined;

    channel?.postMessage({ tabId, ...('data' in value && { ...value.data }) });
    channel?.close();
};

export const useBroadcastChannel = (name: BroadcastChannelsType, callBack: (messageEventData: any) => void) => {
    useEffect(() => {
        const channel = isClient && 'BroadcastChannel' in window ? new BroadcastChannel(name) : null;

        if (!channel) {
            return void null;
        }

        channel.onmessage = (messageEvent) => {
            if (messageEvent.data.tabId !== tabId || broadcastChannelSameTabConfig[name]) {
                callBack(messageEvent.data);
            }
        };

        return () => {
            channel.close();
        };
    }, []);
};
